import { useEffect } from 'react';
import { usePushNotifications } from '@/hooks/use-push-notifications';

/**
 * Component that initializes push notifications when user is logged in.
 * Should be mounted inside AuthProvider.
 */
export const PushNotificationInitializer = () => {
  const { isSupported } = usePushNotifications();

  useEffect(() => {
    if (isSupported) {
      console.log('Push notifications initialized');
    }
  }, [isSupported]);

  return null;
};
